import { Authentication, Credential } from '@models/.';

export function transformAuthenticationData(authentication: Authentication | null): { authentication: Authentication, credential: Credential } | null {
  if (!authentication) return null;
  
  return {
    authentication: {
      ...authentication,
      tiendas: undefined,
    },
    credential: {
      idUsuario: authentication.id,
      cuentas: authentication.cuentas,
      tiendas: [],
    }
  };
}
